import firebase from 'firebase';
import 'firebase/database';

const firebaseConfig = {
  apiKey: "AIzaSyD6ZEDAq-FqjT-eTxc18qU_x34yim-Nkjg",
  authDomain: "pawn-der2.firebaseapp.com",
  databaseURL: "https://pawn-der2.firebaseio.com",
  projectId: "pawn-der2",
  storageBucket: "pawn-der2.appspot.com",
  messagingSenderId: "774580384528",
  appId: "1:774580384528:web:06e31dc8676f0c9f97ab95",
  measurementId: "G-5MH1JRM8BR"
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);
firebase.analytics();

export default firebase;


